import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import RightMenu from "../RightMenu";
import Calendar from "rc-calendar";
import calendar_icon from "../../../assets/images/calendar_icon.png";
import MonthCalendar from "rc-calendar/lib/MonthCalendar";
import CalendarPicker from "rc-calendar";
import CalendarButton from "../CalendarButton";
import RangeCalendar from "rc-calendar/lib/RangeCalendar";
import DatePicker from "react-datepicker";
import Dropdown from "../Dropdown";
import plPL from "rc-calendar/lib/locale/pl_PL";
import enGB from "rc-calendar/lib/locale/en_GB";
import moment from "moment";
import PL from "moment/locale/pl";
import EN from "moment/locale/en-gb";
import RightIconMenu from "../RightIconMenu";

export default class View_type_20 extends Component {
	constructor(props) {
		super(props);
		console.log("View_type_4: ", props);
		{
			this.props.data.calendar_language == "PL"
				? moment.locale("pl")
				: moment.locale("en-gb");
		}

		var data = {
			title: "",
			calendar: [],
			sort: [],
			prev_dropdown: [],
			events: [],
			calendar_picker: false,
			right_menu: [],
			...props.data
		};
		this.state = {
			data: data,
			rightMenu: data.right_menu,
			prevDropdown: data.prev_dropdown,
			date: Object.keys(data.events)[0],
			dateAll: Object.keys(data.events),
			showCalendar: false,
			showMore: false,
			value: undefined,
			startDate: moment(),
			rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],

		};
		console.log("View_type_4:", this.state);
		// console.log('aktualna data z api',this.state.date);
		this.changeDate = this.changeDate.bind(this);
		this.openCalendar = this.openCalendar.bind(this);
		console.log(
			"LOAD THIS>STATE>DATEALL FROM CONSTRUCOT",
			this.state.dateAll[0][(0, 1)]
		);
		console.log(
			"LOAD THIS.STATE.DATEALL.LENght",
			this.state.dateAll[this.state.dateAll.length - 1]
		);
		let pickedDate = moment(
			`'${this.state.prevDropdown.current}-07-${this.state.dateAll[1]}'`,
			"YYYY-MM-DD"
		);
		console.log(pickedDate);
	}

	changeDate(date) {
		this.setState({ date: date.format("DD.MM") });
		// console.log("[changeDateLOG]", this.state.date);
	}

	openCalendar(event) {
		this.setState(prevState => ({
			showCalendar: !prevState.showCalendar
		}));
	}

	render() {
		const selected = {
			border: "1px solid #aa8dc2",
			color: "#666",
			background: "#f4f1f7",
			color: "#a78ac0"
		};
		const dayAndMonth = this.state.dateAll;
		const onlyDay = dayAndMonth.map(elem => {
			return elem.split(".")[0];
		});

		const transformedTime = dayAndMonth;

		const transformedTimeSplited = transformedTime[0].split(".");

		const now = moment();
		const defaultCalendarValue = now.clone();
		const defaultCalendarValue1 = now.clone();

		defaultCalendarValue.date(transformedTimeSplited[0]);
		defaultCalendarValue.add(-transformedTimeSplited[1], "month");
		console.log("[defaultCalendarValue]", defaultCalendarValue);


		var events = Object.assign({}, this.state.data.events);
		let _this = this;

		Object.keys(events)
			.reverse()
			.map((key, index) => {
				key !== this.state.date ? delete events[key] : null;
			});

		var left_col =
			this.state.rightMenu.length || this.state.data.calendar_picker ? 9 : 12;
		var right_col = 12 - left_col;

		const calendar = this.state.showCalendar ? (

			<DatePicker
				style={{
					height: "200%!important"
				}}
				inline
				selected={
					(defaultCalendarValue,
					moment(
						`'${this.state.prevDropdown.current}-08-${onlyDay[0]}'`,
						"YYYY-MM-DD"
					))
				}
				highlightDates={this.highlightWithRanges}
				highlightDates={this.state.dateAll.map(elem => {
					if (elem.split(".")[1] == 8) {
						return moment(
							`'${this.state.prevDropdown.current}-${
								this.state.date.split(".")[1]
							}-${elem}'`,
							"YYYY-MM-DD"
						);
					} else {
						return moment(
							`'${this.state.prevDropdown.current}-${
								elem.split(".")[1]
							}-${elem.split(".")[0] * 1}'`,
							"YYYY-MM-DD"
						);
					}
				})}
				calendarClassName="vt4 absolute_calendar"
				onChange={this.changeDate}
			/>
		) : null;

		return (
			<div className="vt4 main row">
				<div className={"vt4 col-md-12 vt4_content-column col-lg-" + left_col}>
					<div className={"vt4 col-lg-12 artists-pageTitle"}>
						{this.state.data.title}
					</div>
					<div className={"vt4 col-lg-12 top_elements"}>
						<div className="row">
							<div className={"vt4 col-lg-12"}>
								<ul className="vt4 filters">
									{this.state.data.sort.map((object, i) => (
										<li className="vt4 calendar-sortunit" key={i}>
											{object.link == "" ? (
												object.name
											) : (
												<Link className="calendar-sortitem" to={object.link}>
													{object.name}
												</Link>
											)}
										</li>
									))}
								</ul>
							</div>
							<div className="vt4 icons col-md-12 hidden-lg">
								<img
									className="vt4 calendar_icon"
									src={calendar_icon}
									onClick={this.openCalendar}
								/>
								{calendar}
							</div>
						</div>
					</div>

					{this.state.dateAll.map((item, key, key1) => {
						return (
							<div key={key} className={"vt4 col-lg-12"}>
								{Object.keys(events).map(function(key) {
									var obj = events[key];

									return (
										<div className="vt4" key={key}>
											<div className="vt4 col-lg-12 calendar-timeset">
												<div className="vt4 calendarTimesetunit">{item}</div>
												<div className="vt4 calendarWeekDay" />
											</div>

											{Object.keys(obj).map(function(key1) {
												var item = obj[key1];

												return (
													<div className="vt4 row" key={key1}>
														<div className="vt4 col-xs-4 col-sm-4 col-md-4 col-lg-4">
															<div className="vt4 calendarMzName">
																<div className="vt4 calendarMzNameItem calendarMzTimeItem">
																	{item.time}
																</div>
																<div className="vt4 calendarMzNameItem">
																	{item.place}
																</div>
															</div>
														</div>
														<div className="vt4 col-xs-5 col-sm-5 col-md-5 col-lg-5">
															<div className="vt4 center">
																<div className="vt4 calendarContTitle">
																	{item.type}
																</div>

																<div className="vt4 calendarParticipantWrapper">
																	{item.artists.map(function(object, i) {
																		return (
																			<div
																				className="vt4 participantBlock"
																				key={i}
																			>
																				<span className="vt4 calendarNameParticipant">
																					<Link to={object.link}>
																						{object.name}
																					</Link>
																				</span>
																				<span> {object.instrument} </span>
																			</div>
																		);
																	})}
																</div>

																<div className="vt4 calendarProgrammBox">
																	PROGRAM
																</div>
																<div
																	className="vt4 calendarParticipantExtendet"
																	dangerouslySetInnerHTML={{
																		__html: item.lineup
																	}}
																/>
																<div className="vt4 middle-addelem">
																	<AdditionalBlock data={item} />
																</div>
															</div>
														</div>

														<div className="vt4 col-xs-3 col-sm-3 col-md-3 col-lg-3">
															<ul className="vt4 calendarListRightMenu">
																{item.links.map((object, i) => (
																	<li
																		className="vt4 calendarListItemRightMenu"
																		key={i}
																	>
																		<a href={object.link}>{object.name}</a>
																	</li>
																))}
															</ul>
														</div>
													</div>
												);
											})}
										</div>
									);
								})}
							</div>
						);
					})}
				</div>
				<div
					className={
						"vt4 right hidden-xs hidden-sm hidden-md vt4_calendar-column col-lg-" +
						right_col
					}
				>
					{this.state.prevDropdown.length ||
					Object.keys(this.state.prevDropdown).length ? (
						<Dropdown data={this.state.prevDropdown} />
					) : null}

					<DatePicker
						inline
						selected={
							(defaultCalendarValue,
							moment(
								`'${this.state.prevDropdown.current}-08-${onlyDay[-1]}'`,
								"YYYY-MM-DD"
							))
						}
						highlightDates={this.state.dateAll.map(elem => {

							if (
								elem.split(".")[1] == 8 &&
								this.state.date.split(".")[1] * 1 == 8
							) {
								return moment(
									`'${this.state.prevDropdown.current * 1}-${
										this.state.date.split(".")[1]
									}-${elem}'`,
									"YYYY-MM-DD"
								);
							} else {
								return moment(
									`'${this.state.prevDropdown.current}-${
										elem.split(".")[1]
									}-${elem.split(".")[0] * 1}'`,
									"YYYY-MM-DD"
								);
							}

						})}
						calendarClassName="vt4 calendar_right"
						onChange={this.changeDate}
					/>
					/>
					{this.state.rightMenu.length ? (
						<RightMenu className="vt4 right_menu" data={this.state.rightMenu} />
					) : null}
					{this.state.rightIconMenu &&
						<RightIconMenu data={this.state.rightIconMenu}/>
					}
				</div>
			</div>
		);
	}
}

class AdditionalBlock extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showMore: false
		};
		this.openMore = this.openMore.bind(this);
	}

	openMore(event) {
		this.setState(prevState => ({
			showMore: !prevState.showMore
		}));
	}

	render() {
		const more = this.state.showMore ? (
			<div
				dangerouslySetInnerHTML={{
					__html: this.props.data.additional_information
				}}
			/>
		) : null;
		if (
			this.props.data.hasOwnProperty("additional_information") &&
			this.props.data.additional_information
		) {
			return (
				<div className="vt4 more_block">
					<button className="vt4 more_button" onClick={this.openMore} />
					<div className="vt4 more_text">{more}</div>
				</div>
			);
		}

		return null;
	}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_20/index.js